import { render, staticRenderFns } from "./BuyLiCoin.vue?vue&type=template&id=e7cff246&scoped=true"
import script from "./BuyLiCoin.vue?vue&type=script&lang=js"
export * from "./BuyLiCoin.vue?vue&type=script&lang=js"
import style0 from "./BuyLiCoin.vue?vue&type=style&index=0&id=e7cff246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7cff246",
  null
  
)

export default component.exports